var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__path"},[_c('div',{staticClass:"d-flex align-items-md-center"},[_c('nuxt'),_vm._v(" "),_c('toast-container-component')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }